/* eslint-disable no-console */
import React from 'react';
import { StringColumn, CustomColumn } from 'baseui/data-table';
import { Button, KIND, SIZE } from 'baseui/button';

import { EMPTY_STRING } from 'commons-ui';
import userService from 'commons-ui/src/components/versionHistory/utils/useService';
import CustomDateColumn from '../../../baselist/components/CustomDateColumn';

export const COL_NAMES = {
	modifiedBy: 'modifiedBy',
	date: 'date',
	oldObject: 'oldObject',
	newObject: 'newObject'
};

export interface VersionHistoryObject {
	id: string;
	oldObject?: string;
	newObject?: string;
	_id: string;
}

const downloadJSON = (content: string, filename: string) => {
	const blob = new Blob([content], { type: 'application/json;charset=utf-8;' });
	const link = document.createElement('a');

	if (link.download !== undefined) {
		const url = URL.createObjectURL(blob);
		link.setAttribute('href', url);
		link.setAttribute('download', filename);
		link.style.visibility = 'hidden';
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}
};

const useDownloadHandler = () => {
	const { getVersionHistoryObjectById } = userService();

	const handleDownload = async (
		dashboard: string,
		pageName: string,
		entityName: string,
		id: string,
		entityId: string,
		_id: string,
		objectType: string
	) => {
		const result = await getVersionHistoryObjectById(dashboard, pageName, entityName, id, entityId, _id, objectType);
		const { data } = result;
		const object: VersionHistoryObject = data && data.length > 0 ? data[0] : null;
		const objectValue = object[objectType as keyof VersionHistoryObject];
		if (objectValue) {
			downloadJSON(objectValue, `version_history_${objectType}_${_id}.json`);
		}
	};

	return { handleDownload };
};

export const columnConfigs = (dashboard: string, pageName: string, entityName: string, id: string) => [
	CustomDateColumn({
		title: 'Date',
		minWidth: 200,
		maxWidth: 200,
		columnName: COL_NAMES.date
	}),
	StringColumn({
		title: 'Modified By',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.modifiedBy] || EMPTY_STRING
	}),
	CustomColumn({
		title: 'Old Object',
		maxWidth: 200,
		mapDataToValue: (data: any) => ({
			entityId: data.entityID,
			_id: data._id,
			objectType: COL_NAMES.oldObject,
			...data
		}),
		renderCell: (params) => {
			const { handleDownload } = useDownloadHandler();
			const { entityId, _id, objectType } = params.value;
			if (!entityId || !_id) {
				return <span>No data</span>;
			}

			return (
				<Button
					kind={KIND.primary}
					size={SIZE.mini}
					onClick={() => handleDownload(dashboard, pageName, entityName, id, entityId, _id, objectType)}>
					Download
				</Button>
			);
		}
	}),
	CustomColumn({
		title: 'New Object',
		maxWidth: 200,
		mapDataToValue: (data: any) => ({
			entityId: data.entityID,
			_id: data._id,
			objectType: COL_NAMES.newObject,
			...data
		}),
		renderCell: (params) => {
			const { handleDownload } = useDownloadHandler();
			const { entityId, _id, objectType } = params.value;
			if (!entityId || !_id) {
				return <span>No data</span>;
			}

			return (
				<Button
					kind={KIND.primary}
					size={SIZE.mini}
					onClick={() => handleDownload(dashboard, pageName, entityName, id, entityId, _id, objectType)}>
					Download
				</Button>
			);
		}
	})
];
